import React, { useState } from "react"
import styled from "styled-components"

type TooltipDirections = "right" | "bottom"
interface TipProps {
  minWidth?: string
  arrowSize?: string
  direction?: TooltipDirections
}

const defaultArrowSize = "6px"

const TooltipWrapper = styled.div`
  display: inline-block;
  position: relative;
  line-height: 1;
`
const Tip = styled.div<TipProps>`
  position: absolute;
  max-width: 300px;
  ${({ minWidth }) => `min-width: ${minWidth};`}
  border-radius: ${({ theme }) => theme.radius.small};
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  z-index: 100;
  background: ${({ theme }) => theme.blue_900};
  color: ${({ theme }) => theme.white};
  font-size: 11px;
  opacity: 0.9;
  /* If text is short, show it always in one line, */
  /* If its long, allow to wrap */
  ${({ minWidth }) => !minWidth && `white-space: nowrap;`}
  line-height: 1.3;
  ${({ direction }) =>
    direction === "bottom"
      ? `top: calc(100% + 8px);left: 50%; transform:translateX(-50%);`
      : direction === "right"
      ? `left: calc(100% + 8px);top: 50%;transform: translateX(0) translateY(-50%);`
      : null}

  ::before {
    content: " ";
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: ${({ arrowSize }) =>
      arrowSize ? arrowSize : defaultArrowSize};
    margin-left: -${({ arrowSize }) => (arrowSize ? arrowSize : defaultArrowSize)};

    ${({ direction, theme, arrowSize }) =>
      direction === "bottom"
        ? `border-bottom-color: ${theme.blue_900}; bottom: 100%; left:50%;`
        : direction === "right"
        ? `border-right-color: ${
            theme.blue_900
          }; transform: translateX(0) translateY(-50%); left: -${
            arrowSize || defaultArrowSize
          }; top: 50%;`
        : null}
  }
`

const Tooltip = (props) => {
  let timeout
  const [active, setActive] = useState(false)

  const showTip = () => {
    timeout = setTimeout(() => setActive(true), 200)
  }

  const hideTip = () => {
    clearInterval(timeout)
    setActive(false)
  }

  return (
    <TooltipWrapper onMouseEnter={showTip} onMouseLeave={hideTip}>
      {props.children}
      {active && (
        <Tip
          minWidth={props.minWidth}
          direction={props.direction || "right"}
          arrowSize={props.arrowSize}
        >
          {props.tip}
        </Tip>
      )}
    </TooltipWrapper>
  )
}

export default Tooltip
